import { render, staticRenderFns } from "./showProductsCarouselComponent.vue?vue&type=template&id=5b4f6b36"
import script from "./showProductsCarouselComponent.vue?vue&type=script&lang=js"
export * from "./showProductsCarouselComponent.vue?vue&type=script&lang=js"
import style0 from "./showProductsCarouselComponent.vue?vue&type=style&index=0&id=5b4f6b36&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4f6b36')) {
      api.createRecord('5b4f6b36', component.options)
    } else {
      api.reload('5b4f6b36', component.options)
    }
    module.hot.accept("./showProductsCarouselComponent.vue?vue&type=template&id=5b4f6b36", function () {
      api.rerender('5b4f6b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/showProductsCarouselComponent.vue"
export default component.exports